import { render, staticRenderFns } from "./ShowUnknownBranch.vue?vue&type=template&id=697a46dc&"
import script from "./ShowUnknownBranch.vue?vue&type=script&lang=js&"
export * from "./ShowUnknownBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports